import { render, staticRenderFns } from "./proDocs.vue?vue&type=template&id=32796db6&scoped=true"
import script from "./proDocs.vue?vue&type=script&lang=js"
export * from "./proDocs.vue?vue&type=script&lang=js"
import style0 from "./proDocs.vue?vue&type=style&index=0&id=32796db6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32796db6",
  null
  
)

export default component.exports